export default "__VITE_ASSET__dc102955__"